import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-create" }
const _hoisted_2 = { class: "grid-x" }
const _hoisted_3 = { class: "cell small-12 large-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "short-description body-text" }, [
  /*#__PURE__*/_createTextVNode(" Submit a "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pink text-w-black" }, "new project"),
  /*#__PURE__*/_createTextVNode(" and start receiving shortlist with selected candidates for your role. ")
], -1)
const _hoisted_5 = { class: "cell small-12 large-8 x3large-7" }
const _hoisted_6 = { class: "grid-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "kicker" }, " Everything done! ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "heading h1 text-purple-md success-title" }, " Your project has been saved ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "body-text" }, " We’ll start sourcing for candidates to present to you, we’ll follow up with you very soon! ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "body-text" }, " You have questions? Schedule a meeting with our Talent Sorcerers ", -1)
const _hoisted_13 = { class: "button-container grid-x align-center" }
const _hoisted_14 = { class: "cell small-12 large-6" }

import { ref } from 'vue'
import { NButton, NModal } from 'naive-ui';
import router from '@/router';
import { useProjectCreateStore } from "@/stores/projects/create.store";
import ProjectForm from "@/components/client/projects/ProjectForm.vue";
import SideBanner from "@/components/utils/SideBanner.vue";
import { ProjectFormData } from "@/ts/interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCreateView',
  setup(__props) {

const projectCreateStore = useProjectCreateStore()

const showModal = ref<boolean>(false)

const formData = ref<ProjectFormData>({
  role_title: '',
  years_of_experience: null,
  usd_hourly_rate: null,
  job_description: '',
  job_description_link: '',
  skills: [],
  complementary_skills: [],
});

const redirectOnSave = () => {
  router.push({ name: 'client-projects-index' })
}

const submitForm = async () => {
  const response = await projectCreateStore.create(formData.value)

  if(response.ok) {
    showModal.value = true
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SideBanner, {
          "back-route-name": "client-projects-index",
          "banner-text": "New Project",
          "banner-img": "image-new-project.png"
        }, {
          "short-description": _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ProjectForm, {
          "form-data": formData.value,
          onSubmitAction: submitForm
        }, null, 8, ["form-data"])
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: showModal.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
      class: "project-saved-modal",
      preset: "card",
      style: { width: '865px' },
      bordered: false,
      "transform-origin": "center",
      size: "huge",
      "on-after-leave": redirectOnSave
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_router_link, { to: { name: 'meetings' } }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NButton), {
                    size: "large",
                    focusable: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" SCHEDULE A MEETING ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})